module.exports = __webpack_public_path__ + "img/tobala_medals.3bab85e4.png";